<template>
  <div class="animated fadeIn">
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
  </div>
</template>

<script>
import Axios from "axios";
import Var from "./../../../variables";
import moment from "moment-jalaali";
import VueCkeditor from "vue-ckeditor2";

export default {
  components: {
    VueCkeditor,
  },
  data: function () {
    return {
      sections: [],
      newSectionName: "",
      newSectionDialog: false,
      editSectionDialog: false,
      statusOpt: ["فعال", "غیر فعال"],
      selected: "",
      status: "فعال",
      moment: moment,

      filter: "",
      editName: "",
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام انبار" },
        { key: "itemNumber", label: "تعداد محصولات" },
        { key: "operation", label: "عملیات" },
      ],
      sectionName: "",
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      TotalRows: 1,
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
    };
  },

  methods: {
    onfilter(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    openNewSectionDialog() {
      this.newSectionDialog = true;
      this.newSectionName = "";
    },
    openEditSectionDialog(section) {
      this.editSectionDialog = true;
      this.selected = section;
      this.editName = section.name;
    },
    goToitemsperwarehouse(item) {
      this.$router.push("/warehouse/itemsperwarehouse/" + item.id);
    },
    closeEditSectionDialog() {
      this.editSectionDialog = false;
    },
    deleteSection(section) {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseSection/delete",
        {
          warehouseSectionId: section.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.showSection();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    showSection() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouse/sections",
        {
          warehouseId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.sections = res.data;
            this.TotalRows = this.sections.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    addSection() {
      this.newSectionDialog = false;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseSection/new",
        {
          warehouseId: this.$route.params.id,
          name: this.newSectionName,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newSectionName = "";
            this.showSection();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    editSection() {
      this.editSectionDialog = false;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseSection/edit",
        {
          warehouseSectionId: this.selected.id,
          name: this.editName,
          status: this.status,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.showSection();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
  },

  mounted() {
    this.showSection();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.table td {
  text-align: center;
  vertical-align: middle;
}
</style>
